import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onRemoveGuidedFormulationPill = action(
    'onRemoveGuidedFormulationPill',
    (segmentKey: string, scenarioId: SearchScenarioId) => ({
        segmentKey,
        scenarioId,
    })
);

export default onRemoveGuidedFormulationPill;
